import { useEffect, useState } from 'react';

import { Tag, TagInput, TagInputProps } from 'emblor';
import { isEmail } from 'lib/is-email';

type Props = Omit<
  TagInputProps,
  'tags' | 'setTags' | 'setActiveTag' | 'setActiveTagIndex' | 'activeTagIndex'
> & {
  emails?: string[];
  setEmails: (emails: string[]) => void;
};

export const EmailTagInput = ({ emails, setEmails, ...otherProps }: Props) => {
  const [emailsState, setEmailStates] = useState<Tag[]>(
    emails?.map((email) => ({ id: email, text: email })) || [],
  );

  useEffect(() => {
    setEmails(emailsState.map((email) => email.text));
  }, [emailsState]);

  const [activeTag, setActiveTag] = useState<number | null>(null);

  return (
    <TagInput
      tags={emailsState}
      setTags={(updatedEmails) => {
        setEmailStates(updatedEmails);
      }}
      disabled={otherProps.disabled}
      readOnly={otherProps.readOnly}
      addTagsOnBlur={true}
      inputProps={{ inputMode: 'email' }}
      placeholder="Add email address"
      styleClasses={{
        input: 'w-full sm:max-w-[350px] shadow-none',
        tag: {
          // Mirror the default Badge variant — surface-2 fill, hairline
          // border, sharp corners — so email chips read as part of the
          // same chip family used elsewhere in the system. Set padding
          // explicitly because emblor's `border-primary` from the
          // primary variant tw-merges away the base `pl-2`, leaving the
          // text flush to the chip's left edge.
          body: 'h-7 rounded-none border border-[var(--line)] bg-[var(--surface-2)] pl-2 pr-0 text-[var(--text)] hover:bg-[var(--surface-2)]',
          closeButton: 'h-full px-1.5',
        },
        tagList: { container: 'flex-wrap' },
      }}
      activeTagIndex={activeTag}
      setActiveTagIndex={setActiveTag}
      variant="primary"
      validateTag={(tag) => {
        return isEmail(tag);
      }}
    />
  );
};
